import React from 'react'
import css from '@styled-system/css'
import styled from 'styled-components'

import { Box } from 'ui/bend'

const Container = styled(Box)(() =>
  css({
    backgroundColor: '#f2f2f2',
    width: 'fit-content',
    padding: '4px',
    marginBottom: '4px',
    color: '#000',
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '14px',
    letterSpacing: '0.96px',
    textTransform: 'uppercase'
  })
)

export const Badge = ({ children }) => {
  return <Container>{children}</Container>
}
